var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"m-orm-toolbar white",attrs:{"flat":"","color":_vm.color,"height":"auto"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }